'use strict';

const {disableButton} = require('../../common');

const UpgradeModel = require('../models/upgradeModel');

const ErrorView = require('../views/errorView');

const LoaderView = require('../views/loaderView');

const AnalyticsController = require('./analyticsController');

class UpgradeController extends UpgradeModel {
   constructor(newTariffPlan, currentTariff, currentPeriod, licenceId, token, software, method, cancelUrl, returnUrl, cn, total) {
     super(newTariffPlan, licenceId, token, method, cancelUrl, returnUrl);
     this.currentTariff = currentTariff;
     this.currentPeriod = currentPeriod;
     this.cn = cn;
     this.method = method;
     this.total = total;
     this.software = software;
     this.analyticsController = new AnalyticsController(software, currentTariff, currentPeriod, newTariffPlan);
   }

   request(displayLoader, displayError, displayBlock, returnUrl) {
     displayBlock(true);
     displayLoader(true);
     this.analyticsController.createUpgradeLabel();
     this.requestInfo()
       .then(data => {
         if (data.status === 200) {
           return data.json();
         } else {
           throw data;
         }
       })
       .then(res => {
         localStorage.setItem("upgrade", JSON.stringify({
           ...res, newTariffPlan: this.newTariffPlan, licenceId: this.licenceId, token: this.token, period: this.currentPeriod, software: this.software, tariff: this.currentTariff, returnUrl
         }));
         this.analyticsController.send('done', 'upgrade').finally(() => {
           window.parent.location.href = `/upgrade`;
         })
         displayBlock(false);
         displayLoader(false);
       }).catch(() => {
         this.analyticsController.send('reject', 'upgrade');
         displayLoader(false);
         displayError(true);
     });
   }

   upgrade(target) {
     this.errorView = new ErrorView();
     this.loaderView = new LoaderView();
     this.analyticsController.createUpdateLabel(this.method, 'usd', this.total);

     disableButton(true, target);
     this.loaderView.toggle(true);

     this.requestUpgrade()
       .then(data => {
         data.json().then(res => {
           if (data.status === 200) {
             this.analyticsController.send('done', 'update').finally(() => {
               if (res.redirectUrl) {
                 window.location.replace(res.redirectUrl);
               } else {
                 window.location.replace(this.returnUrl);
               }
             });
           } else {
             this.analyticsController.send('reject', 'update');
             this.errorView.displayBlock(res.code);
             disableButton(false, target);
             this.loaderView.toggle(false);
           }
         });
       })
       .catch(() => {
         this.analyticsController.send('reject', 'update');
         this.errorView.displayBlock("default");
         disableButton(false, target);
         this.loaderView.toggle(false);
       })
       .finally(() => {
         localStorage.removeItem('upgrade');
       });
   }

}

module.exports = UpgradeController;
